import { getFeedBackApi } from "../../api/home/feedBackApi";
import {
  GET_FEEDBACK_SUCCESS,
  GET_FEEDBACK_FAILURE,
} from "../types";

export const getFeedBackSuccess = (homepage) => ({
  type: GET_FEEDBACK_SUCCESS,
  payload: homepage,
});

export const getFeedBackFailure = (error) => ({
  type: GET_FEEDBACK_FAILURE,
  payload: error,
});

export const getFeedBack = (postData) => {
  return (dispatch) => {
    getFeedBackApi(postData)
      .then((response) => {
        dispatch(getFeedBackSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getFeedBackFailure(error.message));
      });
  };
};
